import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.stan = bracketIndenting()
